<template>
    <form ref="form">
        <loading-indicator v-if="loading"/>
        <template v-else>
            <div class="row">
                <div class="col-12">
                    <form-row label="Zeitraum">
                        <form-select v-model="type" :options="selectOptions"/>
                    </form-row>
                </div>
                <template v-if="'manual' === type">
                    <div class="col-6">
                        <form-row label="Von" required>
                            <form-input-date v-model="start" type="date" :max="end"/>
                        </form-row>
                    </div>
                    <div class="col-6">
                        <form-row label="Bis" required>
                            <form-input-date v-model="end" type="date" :min="start"/>
                        </form-row>
                    </div>
                </template>
            </div>
        </template>
    </form>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import FormInput from '../../components/form/FormInput.vue';
    import FormInputDate from '../../components/form/FormInputDate.vue';
    import FormRow from '../../components/form/FormRow.vue';
    import FormSelect from '../../components/form/FormSelect.vue';
    import FormTextarea from '../../components/form/FormTextarea.vue';
    import LoadingIndicator from '../../components/LoadingIndicator.vue';
    import {Popup, popupDefaultCancelButton} from '../../library/popup';
    import TopMessageHandler from '../../library/topMessageHandler';

    @Component({
        components: {FormInputDate, LoadingIndicator, FormTextarea, FormSelect, FormRow, FormInput},
    })
    export default class CalendarICSExportPopup extends Vue
    {
        @Prop({
            type: Number,
            required: true,
        }) id: number;

        @Prop({
            type: String,
            required: true,
        }) resource: string;

        @Prop({
            type: String,
            required: false,
            default: '',
        }) fetchUrl: string;

        type = 'all';

        start = '';

        end = '';

        loading = false;

        selectOptions: SelectOption[] = [
            {
                value: 'all',
                label: 'Alle Einträge',
            },
            {
                value: 'future',
                label: 'Alle zukünftigen Einträge',
            },
            {
                value: 'manual',
                label: 'individueller Zeitraum',
            },
        ];

        @Watch('start')
        @Watch('end')
        setButtons()
        {
            this.emitter.emit('setButtons', this.buttons);
        }

        created()
        {
            this.setButtons();
        }

        get buttons()
        {
            return [
                popupDefaultCancelButton,
                {
                    type: 'primary',
                    title: 'Exportieren',
                    icon: 'import_export',
                    cmd: (popup: Popup) => {
                        if ('manual' === this.type && (!this.start || !this.end))
                        {
                            TopMessageHandler.error('Geben Sie bitte ein Start- und Enddatum an, um Einträge mit einem individuellen Zeitraum zu exportieren.');
                            return;
                        }

                        const a = document.createElement('a');
                        a.setAttribute('href', this.exportLink);
                        a.setAttribute('download', 'download');
                        a.setAttribute('target', '_blank');
                        a.click();

                        TopMessageHandler.success('Die Einträge wurden erfolgreich exportiert.');
                        popup.close();
                    },
                }
            ];
        }

        get exportLink()
        {
            let link = (this.fetchUrl || `/${this.resource}/calendar/export/id/${this.id}`) + `/type/${this.type}`;

            if ('manual' === this.type)
            {
                link += `/start/${this.start}/end/${this.end}`;
            }

            return link;
        }
    }
</script>